var _rect, _rect2, _path, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdCreator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 18.3125C22.9062 18.3125 23.0625 18.3906 23.1797 18.5078C23.2969 18.625 23.375 18.7812 23.375 18.9375V19.5625C23.375 19.7383 23.2969 19.8945 23.1797 20.0117C23.0625 20.1289 22.9062 20.1875 22.75 20.1875H19.9375V23C19.9375 23.1758 19.8594 23.332 19.7422 23.4492C19.625 23.5664 19.4688 23.625 19.3125 23.625H18.6875C18.5117 23.625 18.3555 23.5664 18.2383 23.4492C18.1211 23.332 18.0625 23.1758 18.0625 23V20.1875H15.25C15.0742 20.1875 14.918 20.1289 14.8008 20.0117C14.6836 19.8945 14.625 19.7383 14.625 19.5625V18.9375C14.625 18.7812 14.6836 18.625 14.8008 18.5078C14.918 18.3906 15.0742 18.3125 15.25 18.3125H18.0625V15.5C18.0625 15.3438 18.1211 15.1875 18.2383 15.0703C18.3555 14.9531 18.5117 14.875 18.6875 14.875H19.3125C19.4688 14.875 19.625 14.9531 19.7422 15.0703C19.8594 15.1875 19.9375 15.3438 19.9375 15.5V18.3125H22.75Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 1,
    width: 8,
    height: 8,
    rx: 1,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdCreator);
export default __webpack_public_path__ + "static/media/ad-creator.460059e194056a2d6440c8b235b03ecd.svg";
export { ForwardRef as ReactComponent };